import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';

interface ArtistState {
  requirementTypes: string[];
  artStyles: string[];
}
const initialArtistState: ArtistState = {
  requirementTypes: [],
  artStyles: [],
};
const artistSlice = createSlice({
  name: 'artist',
  initialState: initialArtistState,
  reducers: {
    setRequirementTypes: (state, action) => {
      state.requirementTypes = action.payload;
    },
    setArtStyles: (state, action) => {
      state.artStyles = action.payload;
    },
  },
});
export const { setRequirementTypes, setArtStyles } = artistSlice.actions;
export const selectRequirementTypes = (state: RootState) => state.artist.requirementTypes;
export const selectArtStyles = (state: RootState) => state.artist.artStyles;

export default artistSlice.reducer;
